var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureVolumeEllipsoid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26471,0,0,0.794118,-50.8824,43.8824)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 99,
    r: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.79px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.623922,0,0,0.794118,77.9069,27.2059)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.4px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.53681e-17,-0.362682,1.26471,4.86257e-17,-19.2647,154.235)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11668e-16,-1.1451,1.26471,4.86257e-17,-19.2647,222.696)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.83px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.44556e-16,-1.48235,1.26471,4.86257e-17,-19.2647,252.206)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.73px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.81275,0,0,0.794118,-27.6961,27.2059)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.71px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.47882,0,0,0.794118,-84.3971,27.2059)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.54px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,89.2189,65.8865)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "V")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.685039,-1.2326e-32,0,0.245851,15.303,97.5645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.263,106.4L30.263,121.324L15.98,101.425L30.263,81.527L30.263,96.451L167.431,96.451L167.431,81.527L167.431,121.324L167.431,106.4L30.263,106.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.70378e-17,0.441561,-0.245851,1.5054e-17,154.828,47.9438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.138,106.4L38.138,121.324L15.98,101.425L38.138,81.527L38.138,96.451L167.431,96.451L167.431,81.527L167.431,121.324L167.431,106.4L38.138,106.4Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.110007,-0.0887403,0.15436,0.191353,94.1988,118.203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.205,106.4L85.205,121.324L15.98,101.425L85.205,81.527L85.205,96.451L167.431,96.451L167.431,81.527L167.431,121.324L167.431,106.4L85.205,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,48.0628,13.981)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "c")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,19.9722,114.616)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "b")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-67.5978,91.1737)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "a"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureVolumeEllipsoid);
export default __webpack_public_path__ + "static/media/calc-figure-volume-ellipsoid.d80c5770867ca450b42f2ef33a3b9a61.svg";
export { ForwardRef as ReactComponent };